import { Injectable } from '@angular/core';
import { BaseService } from './base/base.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { PaymentResult } from 'src/app/settings/models/stripe-card-view';
import { Observable } from 'rxjs';
import { PackageDetails } from 'src/app/settings/models/package-details.model';
import { OnboardingStatusResult } from 'src/app/settings/models/onboarding-status';
import {
  keyBorrowingReason,
  KeyBorrowingReasonResults,
} from 'src/app/settings/models/KeyBoorrowing-reasons';
import { GeneralSettings } from 'src/app/settings/models/general-settings.model';
import { KeyLabel, KeyLabels } from 'src/app/settings/models/key-label.model';
import {
  KeyAutomationListResult,
  KeyAutomationRule,
  KeyAutomationRules,
} from 'src/app/settings/models/key-automation.model';

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends BaseService {
  private keyAutomateBaseUrl = `${environment.keyAutomate.urlPrefix}/settings/`;
  private agencyBaseUrl = `${environment.agencyMgmt.urlPrefix}`;
  constructor(http: HttpClient) {
    super(http);
  }

  getCardDetails(): Observable<PaymentResult> {
    return this.get<PaymentResult>(`${this.keyAutomateBaseUrl}payment-details`);
  }
  addCard(formData: { cardToken: any }) {
    return this.post<any>(`${this.keyAutomateBaseUrl}add-card`, formData);
  }
  removeCard(id: any) {
    return this.delete<any>(
      `${this.keyAutomateBaseUrl}delete-card?cardId=${id}`,
      {}
    );
  }
  setDefaultCard(formData: { cardId: string }) {
    return this.patch<any>(
      `${this.keyAutomateBaseUrl}set-default-card`,
      formData
    );
  }
  getPackages(): Observable<PackageDetails> {
    return this.get<PackageDetails>(
      `${this.keyAutomateBaseUrl}package-details`
    );
  }

  getOnboardingStatus(): Observable<OnboardingStatusResult> {
    return this.get<OnboardingStatusResult>(
      `${this.keyAutomateBaseUrl}onboarding-status`
    );
  }

  IsKeyAutomateFirstLogging(formData: { IsKeyAutomateFirstLogging: boolean }) {
    return this.patch<any>(
      `${this.agencyBaseUrl}/manager/KeyAutomateLogging`,
      formData
    );
  }

  getGeneralSettings(): Observable<GeneralSettings> {
    return this.get<GeneralSettings>(
      `${this.keyAutomateBaseUrl}general-settings`
    );
  }
  updateGeneralSettings(settings: GeneralSettings) {
    return this.patch<any>(
      `${this.keyAutomateBaseUrl}general-settings`,
      settings
    );
  }

  getKeyBorrowingReasonResults(): Observable<KeyBorrowingReasonResults[]> {
    return this.get<KeyBorrowingReasonResults[]>(
      `${this.keyAutomateBaseUrl}keyborrowing-reasons`
    );
  }

  updateKeyBorrowingReasonSettings(settingsList: keyBorrowingReason) {
    return this.patch<any>(
      `${this.keyAutomateBaseUrl}keyborrowing-reasons`,
      settingsList
    );
  }
  deleteKeyBorrowingReason(id: string) {
    return this.delete<any>(`${this.keyAutomateBaseUrl}keyborrowing-reasons`, {
      BorrowingReasonId: id,
    });
  }

  getKeyLabelResults(): Observable<KeyLabel[]> {
    return this.get<KeyLabel[]>(`${this.keyAutomateBaseUrl}key-labels`);
  }

  updateKeyLabelsSettings(labels: KeyLabels) {
    return this.patch<any>(`${this.keyAutomateBaseUrl}key-labels`, labels);
  }
  systemActivationDetails() {
    return this.post<any>(
      `${this.agencyBaseUrl}/organization/add-system-activation-details`,
      { SystemType: 2 }
    );
  }

  searchProperties(searchKey: string): Observable<any[]> {
    return this.get<any[]>(
      `${this.agencyBaseUrl}/property/search?SearchKey=${searchKey}`
    );
  }
}
